import { Box, Typography } from "@mui/material";

const WhyText = () => {
    return (
        <Box>
            <Typography variant="h5" align="center">Почему выбирают нас?</Typography>
            <Typography variant="body1" align="center">Мы предоставляем услуги по организации и сопровождению сделок <br/>с цифровыми игровыми товарами и внутриигровыми <br/>услугами для популярных онлайн-игр.</Typography>
        </Box>
        
    );
};

export default WhyText;